import React, { useState } from 'react';
import { Dialog, Button, Typography, ButtonGroup, Input, Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { asyncFetch } from '../../helperFunctions';
import { createPinDialog, setSnackbar } from '../redux';

const buttonGroupStyle = { position: 'sticky', width: '100%', top: '0', zIndex: '100' };
const buttonStyle = { width: '100%' };
const margin15px = { margin: '15px' };
const boxStyle = { display: 'flex', flexDirection: 'column' };
const margin20px = { margin: '20px' };

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const [pin, setPin] = useState('');
  const [pinAgain, setPinAgain] = useState('');
  const [loading, setLoading] = useState(false);
  const dialog = useSelector(state => state.tasks.createPinDialog);
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  return (
    dialog && (
      <Dialog open={dialog} fullScreen>
        <div>
          <ButtonGroup style={buttonGroupStyle}>
            <Button
              disabled={loading}
              onClick={async () => {
                if (pin !== pinAgain) {
                  dispatch(setSnackbar({ open: true, message: 'ПИН кодът не съвпада.' }));
                  return;
                }
                if (pin.length < 4 || pin.length > 10) {
                  dispatch(
                    setSnackbar({
                      open: true,
                      message: 'ПИН кодът трябва да е между 4 и 10 символа.',
                    })
                  );
                  return;
                }

                setLoading(true);

                const response = await asyncFetch(
                  `${process.env.REACT_APP_TECHNICIANS_API}/DigitalsSignatures/create-pin`,
                  {
                    method: 'POST',
                    mode: 'cors',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    body: JSON.stringify({
                      pin,
                      pinAgain,
                      userId: null,
                    }),
                  },
                  {
                    'Content-Type': 'application/json',
                  },
                  undefined,
                  dispatch
                );
                setLoading(false);
                if (response.isSuccess) {
                  dispatch(createPinDialog(false));
                } else {
                  dispatch(
                    setSnackbar({
                      open: true,
                      message: response.errorMessage,
                    })
                  );
                }
              }}
              variant="contained"
              color="secondary"
              style={buttonStyle}
            >
              <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                Запази
              </Typography>
            </Button>
          </ButtonGroup>
          <Box style={boxStyle}>
            <Typography style={margin20px}>
              Моля, въведете ПИН код, с който желаете да подписвате електронни документи.
            </Typography>
            <Input
              size="small"
              placeholder="Въведете ПИН"
              type="password"
              margin="none"
              style={margin15px}
              onChange={y => setPin(y.target.value)}
            />
            <Input
              size="small"
              placeholder="Въведете ПИН отново"
              type="password"
              margin="none"
              style={margin15px}
              onChange={y => setPinAgain(y.target.value)}
            />
          </Box>
        </div>
      </Dialog>
    )
  );
};
